import { render } from "./ZeroInvoices.vue?vue&type=template&id=696cc60f"
import script from "./ZeroInvoices.vue?vue&type=script&lang=js"
export * from "./ZeroInvoices.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/eccaplus/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__